export const buildFullURL = context => {
    let fullURL;
    if (process.server && context?.route?.fullPath && process.env.baseUrl) {
        fullURL = `${process.env.baseUrl}${context.route.fullPath}`;
    } else if (process.client) {
        fullURL = window.location.href;
    }
    return fullURL;
};

export const addDomainToPath = path => {
    let domain = process.env.baseUrl;
    if (domain?.endsWith('/')) domain = domain.slice(0, -1);

    if (path.startsWith(domain) || path?.includes('http')) return path;
    if (!path.startsWith('/')) return domain + '/' + path;

    return domain + path;
};
